// Our own test identities must not count as customers (port of bankruptbuy BB-836).
//
// The PostHog project excludes test traffic through one cohort ("Internal /
// Test users": person property $internal_or_test_user = true, OR email
// contains @concept.zone), and the Control Center reads every number through
// it. cc-board-e2e's disposable accounts (jussi+fsE2E-…@concept.zone) never
// open a browser, so the only thing PostHog ever saw of them was the
// server-side signup_complete — on a person with no email, which neither
// clause matched: 44 sign-ups vs 12 real accounts in the week of 2026-09-15.
// Stamping the property wherever an identity is created or identified fixes
// that without a dashboard edit.

const TEST_EMAIL =
  /(\.local$)|(@example\.(com|net|org|test)$)|(^conceptzone(tech|hq)(\+[^@]*)?@gmail\.com$)|(@concept\.zone$)/i;

export function isInternalOrTestEmail(email: string | null | undefined): boolean {
  return !!email && TEST_EMAIL.test(email.trim());
}

/** Person properties that put this identity in the test cohort. Empty for a real person. */
export function testIdentityProps(email: string | null | undefined): { $internal_or_test_user?: true } {
  return isInternalOrTestEmail(email) ? { $internal_or_test_user: true } : {};
}
